import { GiraffeMark } from '../Brand';
import { FadeIn } from '../Reveal';
import { copy } from '../../data/website';

export const AboutCompany = () => <section id="about" className="section-space gee-about" data-testid="about-section">
  <div className="site-container gee-about-layout">
    <FadeIn><GiraffeMark className="about-brand-mark" id="about-giraffe-logo" /><p className="eyebrow" data-testid="about-section-label">{copy.about.label}</p><h2 className="gee-heading" data-testid="about-heading">{copy.about.heading}</h2></FadeIn>
    <div className="gee-prose" data-testid="about-copy">
      {copy.about.paragraphs.map(text => <p key={text}>{text}</p>)}
      <p>{copy.about.intro}</p>
      <ol className="gee-story-formula">{copy.about.steps.map(step => <li key={step}>{step}</li>)}</ol>
      <p className="gee-italic">{copy.about.closing}</p>
    </div>
  </div>
</section>;